var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { InputLabel } from "@material-ui/core";
import { FormControl } from "../form-control";
import { FormHelperText } from "../form-helper-text";
import clsx from "../utils/clsx";
import { getCosmosDataProps } from "../utils/comsosCompat";
import { useId } from "../utils/use-id";
var isFormControlRenderer = function (children) { return typeof children === "function"; };
export var FormField = React.forwardRef(function (props, ref) {
    var idProp = props.id, children = props.children, helperText = props.helperText, error = props.error, label = props.label, disabled = props.disabled, readOnly = props.readOnly, InputLabelProps = props.InputLabelProps, FormHelperTextProps = props.FormHelperTextProps, ErrorHelperTextProps = props.ErrorHelperTextProps, rootProps = __rest(props, ["id", "children", "helperText", "error", "label", "disabled", "readOnly", "InputLabelProps", "FormHelperTextProps", "ErrorHelperTextProps"]);
    var id = useId(idProp);
    var controlId = id + "-control";
    var helperTextId = helperText ? id + "-helperText" : undefined;
    var errorTextId = error ? id + "-feedback" : undefined;
    return (React.createElement(FormControl, __assign({ disabled: readOnly || disabled, error: !!error }, rootProps, { ref: ref }, getCosmosDataProps("form.field")),
        label && (React.createElement(InputLabel, __assign({ htmlFor: controlId }, InputLabelProps), label)),
        isFormControlRenderer(children)
            ? children({ controlId: controlId, helperTextId: helperTextId, errorTextId: errorTextId })
            : React.Children.map(children, function (child) {
                if (!child) {
                    return null;
                }
                if (!React.isValidElement(child)) {
                    return child;
                }
                return React.cloneElement(child, {
                    id: controlId,
                    "aria-describedby": clsx(helperTextId, errorTextId),
                });
            }),
        !!error && (React.createElement(FormHelperText, __assign({ "aria-live": "polite", error: true, id: errorTextId }, ErrorHelperTextProps), error)),
        !!helperText && (React.createElement(FormHelperText, __assign({ error: false, id: helperTextId }, FormHelperTextProps), helperText))));
});
